// extracted by mini-css-extract-plugin
export default {"user":"UserListHoverCard-module__user--YbaRL"};